import styled from 'styled-components'

import { Flex, Box, getPaletteColor } from 'pcln-design-system'

export const FullHeightDiv = styled.div`
  background-color: ${getPaletteColor('background.lightest')};
  min-height: 100%;

  .opacity-mask {
    opacity: 0.6;
  }

  .opacity-mask-pointer-none {
    opacity: 0.6;
    pointer-events: none;
  }
`

export const ListingsHeader = styled(Box)`
  border-top: 1px solid ${getPaletteColor('border.base')};
`

export const ListingsBody = styled(Flex)`
  padding-bottom: 16px;
  margin-bottom: 32px;
  margin-left: auto;
  margin-right: auto;
  max-width: 1380px;
  background-color: ${getPaletteColor('background.lightest')};
`

export const Left = styled.div`
  display: none;
  position: relative;
  width: 100%;
  margin: 0 16px 0 0;

  ${(props) => props.theme.flyQueries.desktop} {
    display: inline-block;
    max-width: 224px;
  }
`

/**
 * Styling notes for listings content:
 *    When ads are disabled, the content should fill to the right as there will not be a right column.
 *    When ads are displayed, content width should take into account right/left columns at each breakpoint.
 */
export const Middle = styled.div`
  width: 100%;
  position: relative;

  ${(props) => props.theme.flyQueries.tablethd} {
    width: calc(100% - ${(props) => (props.displayAds ? '160' : '0')}px);
  }

  ${(props) => props.theme.flyQueries.desktop} {
    padding: 0 10px;
    width: calc(100% - ${(props) => (props.displayAds && !props.is3ShelfVariant ? '430' : '252')}px);
  }

  ${(props) => props.theme.flyQueries.desktoplg} {
    width: calc(100% - ${(props) => (props.displayAds ? '570' : '252')}px);
  }

  ${(props) => props.theme.flyQueries.desktophd} {
    padding: 0;
  }
`

export const BottomAdBox = styled(Box)`
  ${(props) => props.theme.flyQueries.desktoplg} {
    margin-right: 58px;
  }

  ${(props) => props.theme.flyQueries.desktoplg} {
    margin-right: 76px;
  }
`
